import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment/moment';
import 'moment-duration-format';
import { ClickType } from './click-type.model';
import { TimeFormatInterval } from './time-picker-interval';

@Component({
    selector: 'timepicker',
    templateUrl: './timepicker.component.html',
    styleUrls: ['./timepicker.component.css']
})
export class TimepickerComponent implements OnInit {
  private TimeFormat = TimeFormatInterval.TimeFormatMinutes;
  private DurationFormatOptions: moment.DurationFormatSettings = {
      forceLength : false,
      precision : 0,
      template : this.TimeFormat,
      trim : false
  };
  private TimeRangeInterval: moment.Duration = moment.duration(TimeFormatInterval.TimeRangeIntervalDefaultMinutes);
  private readonly TimeRangeMinimum: moment.Duration = moment.duration(TimeFormatInterval.TimeRangeMinimumSeconds);
  private TimeRangeMaximum: moment.Duration = moment.duration(TimeFormatInterval.TimeRangeMaximum).subtract(this.TimeRangeInterval);
  private timeCssClass: string = TimeFormatInterval.TimeMinutesCssClass;
  private zeros = ':00';

  _timeString: string;
  get timeString(): string {
      return this._timeString;
  }
  @Input()
  set timeString(value: string) {
      this._timeString = value ? value
        : (this.TimeFormat === TimeFormatInterval.TimeFormatMinutes
          ? TimeFormatInterval.TimeRangeMinimumMinutes
          : TimeFormatInterval.TimeRangeMinimumSeconds);
      this.selectedTime = moment.duration(
        `${this._timeString}${(this._timeString.length <= 5 ? `${this.zeros}` : '')}`);
  }
  @Input()
  set timeInterval(value: string) {
    this.TimeRangeInterval = moment.duration(value);
    this.TimeRangeMaximum = moment.duration(TimeFormatInterval.TimeRangeMaximum).subtract(this.TimeRangeInterval);
    if (value.length > 5) {
      this.timeCssClass = TimeFormatInterval.TimeSecondsCssClass;
      this.TimeFormat = TimeFormatInterval.TimeFormatSeconds;
      this._timeString = this._timeString.length <= 5 ? `${this._timeString}${this.zeros}` : this._timeString;
      this.DurationFormatOptions.template = this.TimeFormat;
    }
  }
  @Output() timeChanged = new EventEmitter<string>();

  isValid = true;
  selectedTime = this.TimeRangeMinimum;

  constructor() { }

  ngOnInit() {
  }

  onClick(clickType: ClickType): void {
    if (clickType === ClickType.Up) {
      this.selectedTime.add(this.TimeRangeInterval);
      this.selectedTime.subtract(this.timeRounding());
    } else {
        const roundedTime = this.timeRounding();
        this.selectedTime.subtract(this.TimeRangeInterval);
        this.selectedTime.subtract(roundedTime);
        if (roundedTime.minutes() !== moment.duration(TimeFormatInterval.TimeRangeMinimumMinutes).minutes() || roundedTime.seconds() !== moment.duration(TimeFormatInterval.TimeRangeMinimumSeconds).seconds()) {
          this.selectedTime.add(this.TimeRangeInterval);
        }
    }

    this._invalidateSelectedTimeString();

    this.timeChanged.emit(this._timeString);
  }

  timeRounding() {
    let sec = 0;
    let modValue = 0;
    if (this.TimeFormat === TimeFormatInterval.TimeFormatSeconds) {
      sec = this.selectedTime.seconds();
      modValue = sec % this.TimeRangeInterval.seconds();
      if (modValue != 0) {
        return moment.duration('00:00:' + modValue);
      }
    } else if (this.TimeFormat === TimeFormatInterval.TimeFormatMinutes) {
      sec = this.selectedTime.minutes();
      modValue = sec % this.TimeRangeInterval.minutes();
      if (modValue != 0) {
        return moment.duration('00:' + modValue + ':00');
      }
    }

    return moment.duration(TimeFormatInterval.TimeRangeMinimumSeconds);
  }

  onChange(event: any): void {
      const dateTime = new Date(`${moment(new Date).format('M/D/YYYY')} ${event.target.value}`);
      if (!moment(dateTime).isValid()) {
        this.timeChanged.emit(event.target.value);
        return;
      }

      const input = moment.duration(
        `${event.target.value}${(this.TimeFormat === TimeFormatInterval.TimeFormatMinutes ? ':00' : '')}`);
      this.selectedTime = input;

      this._invalidateSelectedTimeString();

      this.timeChanged.emit(this._timeString);
  }

  private _invalidateSelectedTimeString(): void {
    if (this.selectedTime.asHours() >= 24) {
      this.selectedTime = this.TimeRangeMinimum;
    } else if (this.selectedTime.asMilliseconds() < 0) {
      this.selectedTime = this.TimeRangeMaximum;
    }

    this._timeString = this.selectedTime.format(this.TimeFormat, 0, this.DurationFormatOptions);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/timepicker/timepicker.component.ts